import './bootstrap';
import './front';
import './storyblok';
import '../css/app.css';
import '../css/devcube.css';
import '../css/components/CartierAuthorizedDealerBanner.css';
import '../css/components/WelcomeBanner.css';
import React from 'react'
import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ChatProvider } from '@/Components/ChatContext';
import { hydrateRoot } from 'react-dom/client';

const appName = import.meta.env.VITE_APP_NAME || 'Cool Frames';

createInertiaApp({
    title: (title) => {
        if (!title) {
            return appName
        }
        return `${title} - ${appName}`
    },
    resolve: (name) => {
        return resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx'));
    },
    setup: ({el, App, props}) => {
        if (props.initialPage?.url?.indexOf('admin') >= 0) {
            el.classList.add('h-full');
        }

        const zohoWidget = props.initialPage.props.zohoWidget;

        hydrateRoot(el,
            <ChatProvider zohoWidget={zohoWidget}>
                <App {...props} />
            </ChatProvider>
        );
    }
}).then(() => {
    document.getElementById('app').removeAttribute('data-page')
});
